import React, { useState } from 'react';
import PrevNextRow from '../components/PrevNextRow';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { generatePagesBar } from '../components/common/pagination';
import { Spacer } from '../components/common/Decorations';
import '../styles/MentorPage.css';

const MentorTree = () => {
  console.log("Loaded MentorTree");

  const projects = [
    {
      id: 1,
      title: "Сервис логгирования",
      description: "Пишем аналог Sentry, Rollbar и прочих гигантов, которые слишком \"круты\" для работы в России",
      modules: [
        {
          id: 1,
          title: "Введение и настройка окружения",
          steps: [
            {
              id: 1,
              title: "Введение в микросервисы и логгирование",
              description: "Обзор микросервисной архитектуры. Введение в концепцию логгирования и его важность.",
              is_passed: true
            },
            {
              id: 2,
              title: "Установка необходимых инструментов",
              description: "Установка Python и необходимых библиотек. Настройка виртуального окружения.",
              is_passed: false
            },
            {
              id: 3,
              title: "Основы работы с Docker",
              description: "Введение в Docker и его использование в микросервисах. Создание Dockerfile для вашего проекта.",
              is_passed: false
            },
            {
              id: 4,
              title: "Настройка базового проекта",
              description: "Создание структуры проекта. Настройка системы контроля версий (Git).",
              is_passed: false
            },
            {
              id: 5,
              title: "Введение в FastAPI",
              description: "Установка и настройка FastAPI. Создание простого API-эндпоинта.",
              is_passed: false
            }
          ]
        },
        {
          id: 2,
          title: "Основы логгирования",
          steps: [
            {
              id: 1,
              title: "Введение в логгирование",
              description: "Основные концепции и уровни логгирования. Использование стандартной библиотеки logging в Python.",
              is_passed: false
            },
            {
              id: 2,
              title: "Настройка логгирования в приложении",
              description: "Конфигурация логгирования для различных сред. Логгирование в файлы и консоль.",
              is_passed: false
            },
            {
              id: 3,
              title: "Логгирование в микросервисах",
              description: "Логгирование в контексте микросервисов. Интеграция логгирования с FastAPI.",
              is_passed: false
            },
            {
              id: 4,
              title: "Логгирование ошибок и исключений",
              description: "Логгирование ошибок и исключений. Использование try-except блоков для обработки ошибок.",
              is_passed: false
            },
            {
              id: 5,
              title: "Логгирование запросов и ответов",
              description: "Логгирование входящих запросов и исходящих ответов. Использование middleware для логгирования.",
              is_passed: false
            }
          ]
        },
        {
          id: 3,
          title: "Хранение и обработка логов",
          steps: [
            {
              id: 1,
              title: "Введение в базы данных для логов",
              description: "Обзор баз данных, подходящих для хранения логов. Настройка PostgreSQL для хранения логов.",
              is_passed: false
            },
            {
              id: 2,
              title: "Создание модели данных для логов",
              description: "Создание таблиц для хранения логов. Использование SQLAlchemy для работы с базой данных.",
              is_passed: false
            },
            {
              id: 3,
              title: "Запись логов в базу данных",
              description: "Реализация записи логов в базу данных. Оптимизация запросов к базе данных.",
              is_passed: false
            },
            {
              id: 4,
              title: "Обработка и анализ логов",
              description: "Основы анализа логов. Использование SQL-запросов для анализа логов.",
              is_passed: false
            },
            {
              id: 5,
              title: "Визуализация логов",
              description: "Введение в инструменты визуализации. Использование Grafana для визуализации логов.",
              is_passed: false
            }
          ]
        },
        {
          id: 4,
          title: "Интеграция и тестирование",
          steps: [
            {
              id: 1,
              title: "Интеграция с другими сервисами",
              description: "Интеграция с внешними API и сервисами. Использование вебхуков для уведомлений.",
              is_passed: false
            },
            {
              id: 2,
              title: "Написание юнит-тестов",
              description: "Введение в юнит-тестирование. Использование pytest для написания тестов.",
              is_passed: false
            },
            {
              id: 3,
              title: "Интеграционное тестирование",
              description: "Написание интеграционных тестов. Использование pytest и requests для тестирования API.",
              is_passed: false
            },
            {
              id: 4,
              title: "Тестирование производительности",
              description: "Введение в тестирование производительности. Использование locust для нагрузочного тестирования.",
              is_passed: false
            },
            {
              id: 5,
              title: "Развертывание и мониторинг",
              description: "Развертывание приложения на сервере. Мониторинг производительности и логов.",
              is_passed: false
            }
          ]
        },
        {
          id: 5,
          title: "Дополнительные функции и улучшения",
          steps: [
            {
              id: 1,
              title: "Добавление аутентификации",
              description: "Введение в аутентификацию и авторизацию. Использование JWT для аутентификации.",
              is_passed: false
            },
            {
              id: 2,
              title: "Оптимизация производительности",
              description: "Оптимизация запросов к базе данных. Использование кэширования для улучшения производительности.",
              is_passed: false
            },
            {
              id: 3,
              title: "Масштабирование сервиса",
              description: "Введение в масштабирование микросервисов. Использование Kubernetes для оркестрации контейнеров.",
              is_passed: false
            },
            {
              id: 4,
              title: "Безопасность и защита данных",
              description: "Основы безопасности в микросервисах. Защита данных и предотвращение утечек.",
              is_passed: false
            },
            {
              id: 5,
              title: "Заключение и дальнейшие шаги",
              description: "Обзор пройденного материала. Рекомендации по дальнейшему изучению и улучшению сервиса.",
              is_passed: false
            }
          ]
        }
      ]
    }
  ];


  return (
    <div>
      <Header currentPage="mentor" />
      <div className="content">
        <div className="title">ДЕРЕВО ПРОЕКТОВ</div>
        <p className="mentorParagraph">
          Итак, здесь вы можете ознакомиться с задачами, которые позволят вам научиться писать микросервисы на Python.
        </p>
        <p className="mentorParagraph">
          Все материалы, которые вы увидите в этом разделе, бесплатны для личного использования и запрещены для коммерческого использования, так как являются интеллектуальной собственностью и защищены авторским правом.
        </p>
        <div className="navigationTree">
          {projects.map((project, projectIndex) => (
            <div key={project.id} className="navigationTreeProject">
              <div className="navigationTreeProjectTitle" onClick={() => toggleCourse(project.id)}>{projectIndex + 1}. {project.title}</div>
              <div id={`course-${project.id}-description-button`} className="navigationTreeProjectDescriptionButton" onClick={() => toggleCourseDescription(project.id)}>Описание проекта</div>
              <div class="navigationTreeProjectDescription" id={`course-${project.id}-description`}>{project.description}</div>
              <div class="modulesList" id={`course-${project.id}`}>
                {project.modules.map((module, moduleIndex) => (
                  <div key={module.id}>
                    <div className="navigationTreeModuleTitle" onClick={() => toggleModule(project.id, module.id)}>{moduleIndex + 1}. {module.title}</div>
                    <div className="stepsList" id={`module-${project.id}-${module.id}`}>
                      {module.steps.map((step, stepIndex) => (
                        <React.Fragment key={step.id}>
                          <p className="navigationTreeStepTitle">
                            <a href={`/mentor/step/${step.id}`}>
                              {stepIndex + 1}. {step.title}
                              {step.is_passed && (
                                <span
                                  style={{
                                    backgroundColor: 'green',
                                    color: 'white',
                                    borderRadius: '10px',
                                    padding: '0 10px',
                                    marginLeft: '10px'
                                  }}
                                >
                                  Пройден
                                </span>
                              )}
                            </a>
                          </p>
                          <p className="stepDescription">{step.description}</p>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            
            </div>
          ))}
        </div>
        {/* <PrevNextRow nextPage={{ path: '/mentor/tree', title: 'К ДЕРЕВУ ПРОЕКТОВ' }} /> */}
      </div>
      <Footer />
    </div>
  );
};

export default MentorTree;


let openCourseId = null;
let openModuleId = null;

function toggleCourse(courseId) {
    // Закрыть все открытые модули
    document.querySelectorAll('.stepsList').forEach(el => el.style.display = 'none');
    openModuleId = null;

    if (openCourseId && openCourseId !== courseId) {
        document.getElementById(`course-${openCourseId}`).style.display = 'none';
        // Скрыть кнопку описания курса
        const prevDescBtn = document.getElementById(`course-${openCourseId}-description-button`);
        if (prevDescBtn) prevDescBtn.style.display = 'none';
    }

    const courseElement = document.getElementById(`course-${courseId}`);
    const isVisible = courseElement.style.display === 'block';
    courseElement.style.display = isVisible ? 'none' : 'block';

    // Обработка кнопки описания курса аналогично модулю
    const descBtn = document.getElementById(`course-${courseId}-description-button`);
    if (descBtn) descBtn.style.display = isVisible ? 'none' : 'block';

    // Скрыть все описания курсов при сворачивании курса
    if (isVisible) {
        document.querySelectorAll('[id^="course-"][id$="-description"]').forEach(el => {
            el.style.display = 'none';
        });
    }

    openCourseId = isVisible ? null : courseId;
}

function toggleCourseDescription(courseId) {
    // Закрыть все открытые модули
    document.querySelectorAll('.stepsList').forEach(el => el.style.display = 'none');
    openModuleId = null;

    const descElement = document.getElementById(`course-${courseId}-description`);
    if (!descElement) return;

    const isVisible = descElement.style.display === 'block';
    // Скрыть все описания курсов
    document.querySelectorAll('[id^="course-"][id$="-description"]').forEach(el => {
        el.style.display = 'none';
    });

    // Если описание не было видно, показать его
    if (!isVisible) {
        descElement.style.display = 'block';
    }
    // Если было видно, оно уже скрыто
}

function toggleModule(courseId, moduleId) {
    // Скрыть все открытые описания курсов
    document.querySelectorAll('[id^="course-"][id$="-description"]').forEach(el => {
        el.style.display = 'none';
    });

    const moduleEl = document.getElementById(`module-${courseId}-${moduleId}`);

    if (openModuleId && openModuleId !== `${courseId}-${moduleId}`) {
        document.getElementById(`module-${openModuleId}`).style.display = 'none';
    }

    const isVisible = moduleEl.style.display === 'block';
    moduleEl.style.display = isVisible ? 'none' : 'block';

    openModuleId = isVisible ? null : `${courseId}-${moduleId}`;
}